import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from 'antd';
import DeleteButton from './DeleteButton';

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  button {
    margin: 0 5px;
  }
  #T_WoEdit_CancelWo {
    width: 133px;
    height: 49px;
    border-radius: 4px;
    border: solid 1px #979797;
    color: #595959;
    &:hover {
      color: #595959;
    }
  }
  #T_WoEdit_SaveWo {
    width: 133px;
    height: 49px;
    border-radius: 4px;
    background-color: #0080f2;
    &:disabled {
      background: #f5f5f5;
      border-color: #d9d9d9;
    }
  }
`;

const deleteConfirmationText = 'Are you sure you want to remove this work operation from the quote?';

export default function ActionButtons({ isNew, saveDisabled, showDelete, onDelete, onCancel,
  onSave, okText, cancelText }) {
  return (
    <Wrapper>
      {!isNew && showDelete && (
        <DeleteButton
          id="T_WoEdit_DeleteWo"
          onDelete={onDelete}
          confirmationText={deleteConfirmationText}
        />
      )}
      <Button onClick={onCancel} id="T_WoEdit_CancelWo">{cancelText}</Button>
      <Button onClick={onSave} id="T_WoEdit_SaveWo" disabled={saveDisabled}>{okText}</Button>
    </Wrapper>
  );
}

ActionButtons.propTypes = {
  isNew: PropTypes.bool,
  saveDisabled: PropTypes.bool,
  showDelete: PropTypes.bool,
  onDelete: PropTypes.func,
  onCancel: PropTypes.func,
  onSave: PropTypes.func,
  okText: PropTypes.string,
  cancelText: PropTypes.string,
};

ActionButtons.defaultProps = {
  isNew: true,
  saveDisabled: true,
  showDelete: true,
  onDelete: () => {},
  onCancel: () => {},
  onSave: () => {},
  okText: 'Save',
  cancelText: 'Cancel',
};
